/**
 * The body of a record's side panel: its detail screen, loaded when the panel first opens (Spec 76 renders `render`),
 * with a loading shape while the screen's code arrives.
 */
import { type ComponentType, lazy, Suspense } from 'react';
import { SkeletonList } from '../ui/Skeleton.js';
import type { PanelTypeDefinition } from './registry.js';

export interface EntityPanelBodyProps {
  id: string;
  onClose: () => void;
}

/** A panel's `render`, from a lazily loaded screen that takes the record's id. */
export function lazyEntityPanel(
  load: () => Promise<{ default: ComponentType<EntityPanelBodyProps> }>,
): PanelTypeDefinition['render'] {
  const Body = lazy(load);
  return ({ id, onClose }) => (
    <Suspense fallback={<SkeletonList count={4} label="Loading" />}>
      <Body id={id} onClose={onClose} />
    </Suspense>
  );
}
